import type { AlineText } from '../../types';
import type { DiffSegment } from '../layered-diffs';

/**
 * Converts a single text node to a DiffSegment based on its suggestedEdits.
 */
export function convertTextToDiffSegment(textNode: AlineText): DiffSegment {
  const { suggestedEdits, text } = textNode;

  // No suggested edits means this is equal/unchanged text
  if (!suggestedEdits || suggestedEdits.length === 0) {
    return { op: 'equal', text };
  }

  // Look at the first edit to determine the operation type
  // (text nodes typically have one primary edit type)
  const edit = suggestedEdits[0];

  if (edit.type === 'insertNode') {
    return { id: edit.authorId, op: 'insert', text };
  }

  if (edit.type === 'deleteNode') {
    return { id: edit.authorId, op: 'delete', text };
  }

  // For format edits (textFormat), treat as equal since the text content is unchanged
  return { op: 'equal', text };
}
